/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreVacationMetricsResponseDto } from '../../models/core-vacation-metrics-response-dto';

export interface ProjectTasksControllerGetVacationMetrics$Params {
  tenant: string;

/**
 * Project task ID
 */
  id: string;
  from?: string;
  to?: string;
}

export function projectTasksControllerGetVacationMetrics(http: HttpClient, rootUrl: string, params: ProjectTasksControllerGetVacationMetrics$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreVacationMetricsResponseDto>> {
  const rb = new CoreRequestBuilder(rootUrl, projectTasksControllerGetVacationMetrics.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreVacationMetricsResponseDto>;
    })
  );
}

projectTasksControllerGetVacationMetrics.PATH = '/o2-core/project-tasks/{tenant}/{id}/metrics';
